import { createFileRoute } from "@tanstack/react-router"
import { BackofficeClusters } from "modules/backoffice/components/clusters"

export const Route = createFileRoute("/_base/_auth/backoffice/clusters/")({
  component: BackofficeClusters,
})
